import {ok} from 'framework';
import type {Result} from 'framework';
import type {KeyValueStoragePort} from '@/shared/application/ports/key-value-storage.port';
import type {FocusModePreferenceRepository} from '../../application/ports/focus-mode-preference.repository';
import type {FocusModePreference} from '../../domain/focus-mode-preference.value-object';

export const FOCUS_MODE_PREFERENCE_STORAGE_KEY = 'workouts:focus-mode:v1';

const FOCUS_MODE_ON_VALUE = '1';

/**
 * Stores the Focus mode presentation flag in a {@link KeyValueStoragePort}.
 * Read failures and unknown values fall back to off so the user lands on
 * the existing session list instead of an unexpected immersive shell.
 */
export class KeyValueFocusModePreferenceRepository implements FocusModePreferenceRepository {
  constructor(private readonly storage: KeyValueStoragePort) {}

  async get(): Promise<Result<FocusModePreference>> {
    const result = await this.storage.get(FOCUS_MODE_PREFERENCE_STORAGE_KEY);

    if (!result.ok) {
      return ok('off');
    }

    return ok(result.data === FOCUS_MODE_ON_VALUE ? 'on' : 'off');
  }

  set(preference: FocusModePreference): Promise<Result<void>> {
    if (preference === 'on') {
      return this.storage.set(FOCUS_MODE_PREFERENCE_STORAGE_KEY, FOCUS_MODE_ON_VALUE);
    }

    return this.storage.remove(FOCUS_MODE_PREFERENCE_STORAGE_KEY);
  }
}
